<template>
  <div>
    <v-form v-model="valid" ref="mainForm">
      <opq-alert
        type="warning"
        code="service-reference-interdiction-discipline"
        v-if="sas.ficheDisciplineOuverte"
      ></opq-alert>
      <opq-alert type="warning" code="service-reference-aucun-emploi" v-else-if="!hasEmployeursAdmissibles"></opq-alert>
      <opq-catalogue
        code="service-reference-inscription"
        :live="liveSasServiceDeReference(3502)"
        v-model="sasServiceDeReference.desireSinscrire"
        :disabled="nePeutPasSinscrire"
        ref="desireSinscrire"
        @eudo-updated="desireSinscrireCoche"
      ></opq-catalogue>
      <template v-if="veutSinscrire">
        <ressource code="service-reference-choix-employeurs"></ressource>
        <v-checkbox
          class="list_counter_validator my-4 p-0"
          :input-value="hasEmployeursInscrits"
          :rules="[(v) => !!v || 'Veuillez sélectionner au moins un bureau.']"
        ></v-checkbox>
        <emplois-references
          :sas="sas"
          @service-reference-changed="onServiceReferenceChanged"
          :valids="validsEmploisReferences"
          ref="dataIterator_emploisReferences"
        ></emplois-references>
        <opq-case
          :opq-if="hasEmployeursInscrits"
          code="page-personnelle"
          v-model="sasServiceDeReference.sAbonnerALaPagePersonnelle"
          optional
          :live="liveSasServiceDeReference(3503)"
          @eudo-updated="pagePersonnelleCochee"
        ></opq-case>
        <opq-text-field
          :opq-if="hasEmployeursInscrits"
          code="service-reference-courriel"
          is-email
          v-model="sasServiceDeReference.courrielServiceReference"
          :live="liveSasServiceDeReference(3504)"
          optional
        ></opq-text-field>
        <opq-catalogue
          :opq-if="hasEmployeursInscrits"
          code="service-reference-mandat"
          v-model="sasServiceDeReference.mandatsAcceptes"
          :live="liveSasServiceDeReference(3507)"
          optional
          multiple
        ></opq-catalogue>
        <div>
          <ressource v-if="hasEmployeursInscrits" code="information-accessibilite"></ressource>
        </div>
        <opq-case
          :opq-if="hasEmployeursInscrits"
          code="service-reference-intervention-domicile"
          v-model="sasServiceDeReference.interventionDomicile"
          :live="liveSasServiceDeReference(3508)"
          optional
        ></opq-case>
        <opq-case
          :opq-if="hasEmployeursInscrits"
          code="service-reference-modalites"
          v-model="sasServiceDeReference.modalitesServiceReference"
          :live="liveSasServiceDeReference(3510)"
        ></opq-case>
      </template>
    </v-form>
  </div>
</template>

<script>
import CataloguesHelper from "@/mixins/CataloguesHelpers"
import EmploisReferences from "@/components/FormParts/EmploisReferences"
import FormHybrid from "@/mixins/FormHybrid"
import { mapActions } from "vuex"
import { bus } from "@/plugins/bus"

export default {
  mixins: [CataloguesHelper, FormHybrid],
  components: { EmploisReferences },
  props: {
    sas: { type: Object },
  },
  data() {
    return {
      validsEmploisReferences: []
    }
  },
  methods: {
    ...mapActions(["fetchPanier"]),
    liveSasServiceDeReference(cle) {
      return { endpoint: "sas-services-reference", cle: cle, fileId: this.sasServiceDeReference.id }
    },
    desireSinscrireCoche() {
      this.fetchPanier(this.sas.id)
    },
    onServiceReferenceChanged(sasCarteDAffaire) {
      // Callback quand le service de référence change dans le composant EmploisReferences
      this.fetchPanier(this.sas.id)
    },
    pagePersonnelleCochee() {
      this.fetchPanier(this.sas.id)
    },
    estTypeEmploi(item, type) {
      return this.getCatalogueCodeById(2902, item.typeDEmploi) == type
    },
    decocheServiceReference(id) {
      // Déléguer au composant EmploisReferences
      if (this.$refs.emploisReferences) {
        this.$refs.emploisReferences.decocheServiceReference(id)
      }
    },
    inscriptionChanged() {
      if (this.estNon(this.sasServiceDeReference.desireSinscrire)) {
        this.emploisReferencesActifs.forEach((e) => {
          this.decocheServiceReference(e.sasCartesDAffaires)
        })
      }
    },
    checkInscription() {
      if (this.nePeutPasSinscrire) {
        this.$refs["desireSinscrire"].setValueByCode("2")
      } else {
        this.$refs["desireSinscrire"].setValue(this.sasServiceDeReference.desireSinscrire)
      }
    },
  },
  computed: {
    isValid() {
      return (
        this.valid &&
        (!this.veutSinscrire 
          || (this.veutSinscrire && this.validsEmploisReferences.every((x) => x)))
      )
    },
    sasServiceDeReference() {
      return this.sas.sasServiceDeReference
    },
    emploisReferencesActifs() {
      // Récupérer les sasEmploiReference depuis les employeurs (pratique privée actifs)
      return this.employeursAdmissibles?.filter((e) => e.sasEmploiReference?.serviceDeReferenceActif) ?? []
    },
    hasEmployeursInscrits() {
      return this.emploisReferencesActifs.length > 0
    },
    hasEmployeursAdmissibles() {
      return this.employeursAdmissibles.length > 0
    },
    employeursAdmissibles() {
      return (
        this.sas?.employeurs?.filter((e) => this.estTypeEmploi(e, "Pri") && !e.inactif && !e.suspenduTemporairement) ??
        []
      )
    },
    nePeutPasSinscrire() {
      return this.sas.ficheDisciplineOuverte || !this.hasEmployeursAdmissibles
    },
    veutSinscrire() {
      return !this.nePeutPasSinscrire && this.estOui(this.sasServiceDeReference.desireSinscrire)
    },
  },
  created() {
    bus.$on("decocheServiceReference", this.decocheServiceReference)
  },
  mounted() {
    this.checkInscription()
  },
  watch: {
    nePeutPasSinscrire() {
      this.checkInscription()
    },
    validsEmploisReferences() {
      this.$emit("validation-changed", this.isValid)
    },
    veutSinscrire() {
      this.$emit("validation-changed", this.isValid)
    },
  },
}
</script>

<style></style>
